import { useState, useEffect } from "react";
//feature component 
const FeatureContent = ({featureContent})  => {
  const [modal, setModal] = useState(false);
  const [selectedFeature, setSelectedFeature] = useState(null);

    // const toggleSidebar = (featureContentItem) => {
    //   setSelectedFeature(featureContentItem)
    //     setIsOpen(!isOpen);
    // };

    const openSidebar = (featureContentItem) => {
      setSelectedFeature(featureContentItem)
      setModal(!modal);
  };

  const closeSidebar = () => {
    setSelectedFeature(null);
      setModal(false);
  };
  useEffect(() => {
    // Add or remove the class from the html element based on isOpen state
    if (modal) {
        document.documentElement.classList.add('overflow-hidden');
    } else {
        document.documentElement.classList.remove('overflow-hidden');
    }

    // Cleanup function to remove class when component unmounts
    return () => {
        document.documentElement.classList.remove('overflow-hidden');
    };
}, [modal]);

    return(
        <>
        <div className="row">
        {Array.isArray(featureContent) && featureContent.slice(0, 4).map((featureContentItem) => (
            <div className="col-12 col-lg-3 " key={featureContentItem.id}>
              <div className="feature-panel" onClick={() => openSidebar(featureContentItem)} style={{ backgroundColor: featureContentItem.color ? featureContentItem.color : '#e9f2f4' }}>
                <div className="feature-icon">
                  <div className="bg-img"><div style={{ backgroundColor: featureContentItem.color ? featureContentItem.color : '#e9f2f4'}} ></div></div>
                 {featureContentItem.iconSrc ? <img alt={featureContentItem.title} className="featureIcon" src={featureContentItem.iconSrc} /> : ''} 
                </div>
                <div className="feature-content">
                  <h3>{featureContentItem.title}</h3>
                  <p>{featureContentItem.content}</p>
                </div>
              </div>
            </div>
        ))}
        </div>
     
      <div className={`overlay-bg ${modal ? 'open' : ''}`}>
        <div className={`sidebar ${modal ? 'open' : ''}`}>
            <button className="sidebar-close-btn" onClick={closeSidebar}>
                &times;
            </button>
            {modal?( 
              <>
               <h4>{selectedFeature.title}</h4>
               <p>{selectedFeature.content}</p>
              </>
            ): null}
           
        </div>
      </div>
      
        </>
    );
}

export default FeatureContent;